// src/config/env.ts
// Single validated source of truth for all environment variables.
// NOTE: Cookie auth is fully managed by the Spring Boot backend (httpOnly cookies).
// No cookie-related env vars are needed on the frontend.

function requireEnv(key: string): string {
  const value = import.meta.env[key]
  if (!value || typeof value !== 'string' || value.trim() === '') {
    throw new Error(
      `[Dualon] Missing required environment variable: ${key}. ` +
      `Please check your .env file and ensure it is set.`
    )
  }
  return value
}

export const ENV = {
  API_URL:  requireEnv('VITE_API_URL'),
  APP_NAME: requireEnv('VITE_APP_NAME'),
} as const
